import styled from "styled-components";

export const HistoricalWrapper = styled.div`
    width: 1000px;
    margin: 0 auto;
    @media screen and (max-width: 750px) {
        width: 100%;
    }
`;

export const SwiperWrapper = styled.div`
    overflow: hidden;
    .swiper-container {
        padding-bottom: 60px;
    }

    .swiper-slide {
        width: 650px;
    }
    .swiper-slide img {
        display: block;
        width: 100%;
    }

    @media screen and (max-width: 750px) {
        .swiper-slide {
            width: 100%;
        }

        .swiper-container {
            padding-bottom: 30px;
        }
    }
`;
